import * as React from "react";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

export default function SmartLocksPopover({ popperId, openPopper, anchorEl, handleClosePopOver, handleClickOpen, handleNavigate, activeUnit, handleModalView, getTicket }) {
	const handleAction = async (modalview) => {
		if (modalview === "tempPassword") {await getTicket();}
		handleModalView(modalview);
		handleClickOpen();
		handleClosePopOver();
	};
	return (
		<div style={{ zIndex: 20000 }}>
			<Popover
				id={popperId}
				open={openPopper}
				anchorEl={anchorEl}
				onClose={handleClosePopOver}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
			>
				<Stack sx={{ padding: "10px", alignContent: "left" }}>
					<Button sx={{ color: "black", padding: "10px" }} onClick={() => handleNavigate(activeUnit)}>
						<RemoveRedEyeIcon sx={{ fontSize: "16px", marginRight: "5px" }} />
						View Details
					</Button>
					<Divider />
					<Button sx={{ color: "black", padding: "10px" }} onClick={() => handleAction("tempPassword")}>
						Create Temporary Password
					</Button>
					<Divider />
					<Button sx={{ color: "black", padding: "10px" }} onClick={() => handleAction("unlockRemote")}>
						Unlock Remotely
					</Button>
				</Stack>
			</Popover>
		</div>
	);
}